import React, { useState, useRef } from 'react';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import ContactsComponent from '../contacts/contacts';
import saga_logo from 'src/assets/saga_logo.png';
import kivit_logo from 'src/assets/kivit_logo.png';
import orkestadoc_logo from 'src/assets/orkestadoc_logo.png';
import orkestamedia_logo from 'src/assets/orkestamedia_logo.png';
import home_card_1 from 'src/assets/home_card_1.png';
import home_card_2 from 'src/assets/home_card_2.png';
import home_card_3 from 'src/assets/home_card_3.png';
import home_card_4 from 'src/assets/home_card_4.png';
import home_card_5 from 'src/assets/home_card_5.png';
import home_card_6 from 'src/assets/home_card_6.png';
import home_card_7 from 'src/assets/home_card_7.png';
import home_card_8 from 'src/assets/home_card_8.png';
import home_card_9 from 'src/assets/home_card_9.png';
import useHeaderStore from 'src/store/useHeaderStore';
import { Box, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const HomeComponent: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const setSelectedOption = useHeaderStore((state) => state.setSelectedOption);
  const carouselRef = useRef<HTMLDivElement>(null);

  const images = [
    saga_logo,
    kivit_logo,
    orkestadoc_logo,
    orkestamedia_logo,
  ];

  const cards = [
    { image: home_card_1, title: t('HOME_CARD_1_TITLE'), description: t('HOME_CARD_1_DESCRIPTION') },
    { image: home_card_2, title: t('HOME_CARD_2_TITLE'), description: t('HOME_CARD_2_DESCRIPTION') },
    { image: home_card_3, title: t('HOME_CARD_3_TITLE'), description: t('HOME_CARD_3_DESCRIPTION') },
    { image: home_card_4, title: t('HOME_CARD_4_TITLE'), description: t('HOME_CARD_4_DESCRIPTION') },
    { image: home_card_5, title: t('HOME_CARD_5_TITLE'), description: t('HOME_CARD_5_DESCRIPTION') },
    { image: home_card_6, title: t('HOME_CARD_6_TITLE'), description: t('HOME_CARD_6_DESCRIPTION') },
    { image: home_card_7, title: t('HOME_CARD_7_TITLE'), description: t('HOME_CARD_7_DESCRIPTION') },
    { image: home_card_8, title: t('HOME_CARD_8_TITLE'), description: t('HOME_CARD_8_DESCRIPTION') },
    { image: home_card_9, title: t('HOME_CARD_9_TITLE'), description: t('HOME_CARD_9_DESCRIPTION') },
  ];

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + cards.length) % cards.length);
  };

  return (
    <div className={classes.homeContainer}>
      <h1 className={classes.homeTitle}>{t('HOME_TITLE')}</h1>

      <p className={classes.homeDescription}>{t('HOME_TITLE_DESCRIPTION')}</p>

      <button
        className={classes.showMoreButton}
        onClick={() => {setSelectedOption('solutions');}}
      >
        {t('SHOW_MORE')}
      </button>

      <div className={classes.imagesContainer}>
          <img
            src={saga_logo}
            alt={`Imagen ${saga_logo + 1}`}
            className={classes.largeImage}
          />
          <img
            src={kivit_logo}
            alt={`Imagen ${kivit_logo + 1}`}
            className={classes.kivitImage}
          />
          <img
            src={orkestadoc_logo}
            alt={`Imagen ${orkestadoc_logo + 1}`}
            className={classes.largeImage}
          />
          <img
            src={orkestamedia_logo}
            alt={`Imagen ${orkestamedia_logo + 1}`}
            className={classes.orkestaMediaImage}
          />
      </div>

      <br />

      <Box className={classes.carouselContainer}>
        <Box ref={carouselRef} className={classes.carouselContent}>
          <div className={classes.cardsContainer}>
            {[0, 1, 2].map((offset) => (
              <div key={offset} className={classes.card}>
                <img
                  src={cards[(currentIndex + offset) % cards.length].image}
                  alt={cards[(currentIndex + offset) % cards.length].title}
                  className={classes.cardImage}
                />
                <h3 className={classes.cardTitle}>
                  {cards[(currentIndex + offset) % cards.length].title}
                </h3>
                <p className={classes.cardDescription}>
                  {cards[(currentIndex + offset) % cards.length].description}
                </p>
              </div>
            ))}
          </div>
        </Box>
      </Box>
      <div>
        {/* Flecha izquierda */}
        <IconButton className={`${classes.carouselArrow}`} onClick={handlePrev}>
          <ChevronLeft style={{color: 'white'}}/>
        </IconButton>
        {/* Flecha derecha */}
        <IconButton className={`${classes.carouselArrow}`} onClick={handleNext}>
          <ChevronRight style={{color: 'white'}}/>
        </IconButton>
      </div>

      <ContactsComponent />
    </div>
  );
};

export default HomeComponent;